module.exports = __webpack_public_path__ + "static/media/ico-404.5415767c.svg";